"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NumberSqliteHandler", {
    enumerable: true,
    get: function() {
        return NumberSqliteHandler;
    }
});
const _numbergeneralhandler = require("./number.general.handler");
const _decimalsqlitehandler = require("~/db/field-handler/handlers/decimal/decimal.sqlite.handler");
let NumberSqliteHandler = class NumberSqliteHandler extends _decimalsqlitehandler.DecimalSqliteHandler {
    constructor(...args){
        super(...args), this.numberGeneralHandler = new _numbergeneralhandler.NumberGeneralHandler(), this.parseUserInput = this.numberGeneralHandler.parseUserInput;
    }
};
